module.exports = __webpack_public_path__ + "img/toubiao.5dbe75fc.png";